import { Pipe, PipeTransform } from '@angular/core'

import { EM_DASH } from '../../../constants/constant.content'
import {
  NUMBER_TEN,
  NUMBER_THREE,
  NUMBER_TWO,
} from '../../../constants/constant.numbers'

@Pipe({
  name: 'percentage',
})
export class PercentagePipe implements PipeTransform {
  transform(value: any, decimals?: number): any {
    let parsedReturnValue: string | number
    if (isNaN(parseInt(value, NUMBER_TEN))) {
      return EM_DASH
    }
    if (
      parseFloat(value).toFixed(NUMBER_THREE).toString() ===
      parseFloat('0').toFixed(NUMBER_THREE).toString()
    ) {
      return EM_DASH
    }
    if (!decimals) {
      decimals = NUMBER_TWO
    }
    parsedReturnValue = parseFloat(value)
    const zeroString = '-' + parseFloat('0').toFixed(decimals)
    parsedReturnValue = parseFloat(String(parsedReturnValue)).toFixed(decimals)
    // To handel -0.xx. Return positive Zero.
    if (parsedReturnValue === zeroString) {
      parsedReturnValue = parseFloat('0').toFixed(decimals)
    }
    return parsedReturnValue + '%'
  }
}
